module.exports = __webpack_public_path__ + "static/GT-America-Compressed-Medium-5d9395f7fdde28e04b45a9a3145ff494.woff2";